/**
 * 都道府県で絞り込みに使用するパラメーター
 */
export const PRE_ONLY_FLG_PARAM = {
  ALL: 'all',
  RECRUITING_ONLY_IN_SET_LOC: 'recruitingOnlyInSetLoc',
};

/**
 * 近隣エリア表示パターンの絞り込みに使用するパラメーター
 */
export const nearAreaParamsMap = {
  pr: 'prefectureIdList',
  ci: 'cityIdList',
  wa: 'wardIdList',
  st: 'stationIdList',
} as const;

/*
 * 置き換え対象のテキスト
 */
export const REPLACE_TEXT = {
  TITLE: '{title}',
  CONDITION: '{condition}',
  CONDITION_AND: 'など、',
};

/** ページタイトルの説明文 */
export const EXPLAIN_TEXT = `${REPLACE_TEXT.TITLE}の転職・求人検索結果です。${REPLACE_TEXT.CONDITION}${REPLACE_TEXT.CONDITION_AND}左の求人検索条件にて絞込みができます。`;

/** 近隣エリアの説明文 */
export const NEAR_AREA_EXPLAIN_TEXT = '%s近隣%sの求人を表示しています。';

/** SeoTextSelectorのデフォルトのページタイトル */
export const DEFAULT_SEO_TITLE = '転職・求人情報検索' as const;

/** デフォルトのページタイトル */
export const DEFAULT_TITLE = '求人情報の検索結果一覧' as const;

/**
 * 総件数以上のページ数が指定された際のリダイレクト時に正規化するパラメータ
 * pageを残すと1ページ目にリダイレクトしないので含めない
 */
export const STATIC_PARAMS = [
  'ind',
  'ar',
  'pr',
  'ci',
  'wa',
  'rt',
  'st',
  'oc',
  'op',
  'ha',
  'ne',
  'es',
  'k',
  'preBtn',
  'btn',
  'tp',
  'ss',
  'kwc',
  'ni',
  'niwc',
  'nearArea',
  'baseArea',
];

/**
 * リダイレクト時に引き継がないパラメータ
 */
export const UN_EXTEND_PARAMS = ['page', 'usrclk_searchList'];
